export default __webpack_public_path__ + "static/media/banner-committees.edbee1ba.webp";